<template>
  <div class="psa__content col-12">
    <div class="psa__loading-wrapper col-md-12" v-if="fetchingFullFeed || errorFullFeed">
      <div class="psa__loading-spinner" v-if="fetchingFullFeed">
        <i class="fa fa-spinner fa-spin fa-4x"></i>
      </div>

      <div v-if="errorFullFeed" class="psa__error-fetching-container">
        <div>{{ lang.get("event_strings.photo_stream.error_loading") }}</div>
        <div class="psa__reload-btn bg-warning" @click="reloadWindow()">
          {{ lang.get("event_strings.refresh_button") }}
        </div>
      </div>
    </div>

    <div
      v-if="this.photos.length == 0 && !errorFullFeed && !fetchingFullFeed"
      class="psa__status messages"
      v-cloak
    >
      <div class="psa__no-posts"><span v-html="lang.get('event_strings.photo_stream.no_posts')"></span></div>
    </div>

    <div class="psa__card-containter col-12" :class="'max-num-columns-' + maxNumColumns" v-if="!fetchingFullFeed">
      <photo-stream-column
        v-for="index in parseInt(forcedColumn)"
        :key="'photo-stream-col-' + index"
        v-bind:photos="slicePhotos(index)"
        @like="likePost"
        @unlike="unLikePost"
        @comment="commentOnPhoto"
        @approved-photo="approvedPhoto"
        @denied-photo="deniedPhoto"
        @delete-photo="deletePhoto"
        @edit-photo="handleEditPhoto"
        @column-resize="changeColumnLayout"
        @edit-comment="editCommentOnPhoto"
        v-bind:requiresApproval="requiresApproval"
        v-bind:canManage="canManage"
        v-bind:eventAttendee="eventAttendee"
        v-bind:apiAuthToken="apiAuthToken"
        v-bind:eventId="eventId"
        v-bind:streamId="streamId"
        v-bind:base-url="baseUrl"
        v-bind:is-web="isWeb"
        v-bind:subheader-one="subheaderOne"
        v-bind:subheader-two="subheaderTwo"
      >
      </photo-stream-column>
      <div
        aria-label="Click to see more posts"
        class="psa__show-more-btn btn-primary"
        @click="getBeforeFeed()"
        v-if="!lazyLoadEnabled && !this.fetchingBeforeFeed && this.hasMoreFeed"
      >
        <span class="show-more-text">
          {{ lang.get("event_strings.photo_stream.show_more") }}
        </span>
      </div>
      <div
        class="show-more-spinner"
        v-if="this.fetchingBeforeFeed && !fetchingFullFeed && !errorFullFeed"
      >
        <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
      </div>
    </div>
    <div class="psa__post-btn-container">
      <div
        aria-label="Create post button"
        class="psa__post-btn btn btn-primary"
        ref="showModalBtn"
        @click="openModal()"
        v-if="this.initialized"
      >
        <i class="fa fa-plus"></i>
        <span class="psa__post-btn-text">{{
          lang.get("event_strings.photo_stream.make_post")
        }}</span>
      </div>
    </div>
    <photo-stream-modal
      v-if="showModal"
      v-on:close="closeModal"
      v-bind:fetching="fetching.submittingPhoto"
    >
      <template #header>
        <div class="title">
          {{ lang.get("event_strings.photo_stream.make_post") }}
        </div>
        
        <div class='np-modal__user-info base-np-modal-user-info'>
          <div class='np-modal__avatar-wrapper col-xs-2'>
            <div v-if="userAvatarUrl">
              <img class='np-modal__user-avatar' :src="userAvatarUrl">
            </div>
            <div class="np-modal__user-avatar" v-if="!userAvatarUrl">
              <span>{{ initials }}</span>
            </div>
          </div>
        
          <div class='np-modal__posters-name col-xs-10'>
            {{ `${eventAttendee.attendee_fields.first_name} ${eventAttendee.attendee_fields.last_name}`}}
          </div>
        </div>
      </template>
      <template #body>
        <photo-form
          v-bind:eventAttendee="eventAttendee"
          v-bind:submittingPhoto="fetching.submittingPhoto"
          v-bind:api-auth-token="apiAuthToken"
          v-bind:event-id="eventId"
          v-bind:base-url="baseUrl"
          v-bind:camera-type="cameraType"
          v-bind:photoToEdit="photoToEdit"
          @submit-file-post="submitFilePost"
          @submit-text-post="submitTextPost"
        >
        </photo-form>
      </template>
    </photo-stream-modal>
    <div
        aria-label="Click to see more posts"
        class="col-8 base-psa__show-more-btn btn-primary"
        @click="getBeforeFeed()"
        v-if="!lazyLoadEnabled && !this.fetchingBeforeFeed && this.hasMoreFeed"
      >
        <span class="show-more-text">
          {{ lang.get("event_strings.photo_stream.show_more") }}
        </span>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import PhotoStreamSearch from "../../components/photo-stream/PhotoStreamSearch";

var toastConfig = {
  type: "success",
  duration: 4000,
  position: "bottom-right",
  action: {
    text: "DISMISS",
    onClick: (e, toastObject) => {
      toastObject.goAway(0);
    },
  },
};
var timeout;

export default {
  props: [
    "eventId",
    "streamId",
    "manage",
    "apiAuthToken",
    "attendee",
    "eventAttendee",
    "userAvatarUrl",
    "goToPost",
    "baseUrl",
    "isWeb",
    "subheaderOne",
    "subheaderTwo",
    "maxNumColumns",
    "lazyLoadEnabled",
    "isBaseStyle"
  ],

  components: {
    PhotoStreamSearch,
  },

  data() {
    return {
      fetching: {
        fullFeed: this.$fetchStates.fetching,
        beforeFeed: this.$fetchStates.fetching,
        afterFeed: this.$fetchStates.idle,
        submittingPhoto: this.$fetchStates.idle,
        approvingPhoto: this.$fetchStates.idle,
      },
      showModal: false,
      newestRecordCreatedAt: null,
      oldestRecordCreatedAt: null,
      photos: [],
      photoPreview: null,
      hasMoreFeed: true,
      photoErrorMessage: "Error uploading post",
      photoSuccessMessage: "Your post has been created successfully",
      photoEditSuccessMessage: "Your post has been edited successfully",
      cameraType: "photo_and_video",
      requiresApproval: false,
      search: this.value,
      subheaders: [],
      forcedColumn: this.maxNumColumns,
      initialLazyLoad: null,
      photoToEdit: null
    };
  },

  provide() {
    return {
      isBaseStyle: this.isBaseStyle
    }
  },

  computed: {
    canManage() {
      return this.manage === "1";
    },

    fetchingBeforeFeed() {
      return this.fetching.beforeFeed === this.$fetchStates.fetching;
    },

    fetchingFullFeed() {
      return this.fetching.fullFeed === this.$fetchStates.fetching;
    },

    errorFullFeed() {
      return this.fetching.fullFeed === this.$fetchStates.error;
    },

    initialized() {
      return this.fetching.fullFeed === this.$fetchStates.success;
    },

    initials: function () {
      const attendee_fields = this.eventAttendee.attendee_fields
      if (attendee_fields.first_name && attendee_fields.last_name) {
        return  `${attendee_fields.first_name[0]} ${attendee_fields.last_name[0]}`
      }
    },
  },

  watch: {
    search(val) {
      console.log("new search:", val);
    },
    value(val) {
      console.log("new v:", val);
    },
  },

  methods: {
    handleEditPhoto(photo) {
      this.photoToEdit = photo;
      this.openModal()
    },
    slicePhotos(columnIndex) {
      const slicedArray = this.photos.filter(
        (photo, photoIndex) =>
          (photoIndex + 1) % parseInt(this.forcedColumn) ===
          columnIndex % parseInt(this.forcedColumn)
      );
      return slicedArray;
    },

    forceColumn(newCol) {
      this.forcedColumn = newCol;
    },

    listenerForColumnLayout() {
      clearTimeout(timeout);
      timeout = setTimeout(this.changeColumnLayout, 250);
    },
    changeColumnLayout() {
      if (window.innerWidth > 972) {
        if (this.maxNumColumns === "3" && this.forcedColumn !== "3") this.forcedColumn = "3";
      } else if (window.innerWidth <= 962 && window.innerWidth > 628) {
        if (this.maxNumColumns !== "1" && this.forcedColumn !== "2") this.forcedColumn = "2";
      } else if (window.innerWidth <= 628) {
        if (this.forcedColumn !== "1") this.forcedColumn = "1";
      }
    },

    executePhotostreamSearch() {},

    closeModal() {
      this.showModal = false;
      this.photoToEdit = null;
    },

    openModal() {
      this.showModal = true;
    },

    getFormattedURL(relativePath) {
      var url = relativePath;

      if (this.isWeb != "true") {
        url = `/events/${this.eventId}` + url;
      }

      if (
        (typeof this.baseUrl === "string" || this.baseUrl instanceof String) &&
        this.baseUrl != ""
      ) {
        url = this.baseUrl + url;
      }

      return url;
    },

    fetchFeed(search = null) {
      var url = this.getFormattedURL(`/photo-streams/${this.streamId}/feed`);

      this.fetching.fullFeed = this.$fetchStates.fetching;
      axios
        .get(url, {
          params: {
            api_auth_token: this.apiAuthToken,
            manage: this.canManage,
            search: search,
          },
        })
        .then((response) => {
          this.photos = response.data.photos;
          this.newestRecordCreatedAt = response.data.newest_record_created_at;
          this.oldestRecordCreatedAt = response.data.oldest_record_created_at;
          if (response.data.photos.length < 10) this.hasMoreFeed = false;
          this.fetching.fullFeed = this.$fetchStates.success;
          this.fetching.beforeFeed = this.$fetchStates.idle;
          this.photoErrorMessage = response.data.error_message;
          this.upload_success_message = response.data.upload_success_message;
          this.cameraType = response.data.camera_type;
          this.requiresApproval = response.data.requires_approval;
          this.pollFeed();
          this.scrollToPost();
        })
        .catch((e) => {
          console.log("Error", e);
          this.fetching.fullFeed = this.$fetchStates.error;
        });
    },

    scrollToTop() {
      setTimeout(() => {
        var contentBlock = document.getElementById("content-block");
        if (contentBlock) contentBlock.scrollTo({ top: 0, behavior: "auto" });
      }, 1);
    },

    scrollToPost() {
      setTimeout(() => {
        var post = document.getElementById("psa-card-" + this.goToPost);
        if (post) post.scrollIntoView({ behavior: "smooth" });
      }, 1);
    },

    pollFeed() {
      setTimeout(() => {
        this.getAfterFeed();
        this.pollFeed();
      }, 20000);
    },

    getBeforeFeed() {
      if (this.fetchingBeforeFeed) return;

      this.fetching.beforeFeed = this.$fetchStates.fetching;

      var url = this.getFormattedURL(`/photo-streams/${this.streamId}/more_feed`);

      axios
        .get(url, {
          params: {
            api_auth_token: this.apiAuthToken,
            manage: this.canManage,
            datetime: this.oldestRecordCreatedAt,
          },
        })
        .then((response) => {
          this.photos = [...this.photos, ...response.data.photos];
          this.oldestRecordCreatedAt = response.data.oldest_record_created_at;
          if (response.data.photos.length < 10) this.hasMoreFeed = false;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.fetching.beforeFeed = this.$fetchStates.idle;
        });
    },

    getAfterFeed() {
      this.fetching.afterFeed = this.$fetchStates.fetching;

      var url = this.getFormattedURL(`/photo-streams/${this.streamId}/new_feed`);

      axios
        .get(url, {
          params: {
            api_auth_token: this.apiAuthToken,
            manage: this.canManage,
            datetime: this.newestRecordCreatedAt,
          },
        })
        .then((response) => {
          var oldPhotos = response.data.photos.filter((photo) =>
            this.photos.find((foto) => foto.id === photo.id)
          );
          var newPhotos = response.data.photos.filter(
            (photo) => !this.photos.find((foto) => foto.id === photo.id)
          );
          this.photos = [...newPhotos, ...this.photos];
          this.photos = this.photos.map((obj) => oldPhotos.find((o) => o.id === obj.id) || obj);
          if (response.data.newest_record_created_at) {
            this.newestRecordCreatedAt = response.data.newest_record_created_at;
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.fetching.afterFeed = this.$fetchStates.idle;
        });
    },

    reloadWindow() {
      window.location.reload();
    },

    toastSuccessPostPhoto(photoSuccessMessage) {
      Vue.toasted.show(photoSuccessMessage, toastConfig);
    },

    toastErrorPostPhoto() {
      Vue.toasted.show(this.photoErrorMessage, Object.assign({}, toastConfig, { type: "error" }));
    },

    submitTextPost(comment, userTags, postId) {
      this.fetching.submittingPhoto = this.$fetchStates.fetching;

      var url = this.getFormattedURL(`/photo-streams/${this.streamId}/post_item`);

      axios({
        url: url,
        data: {
          api_auth_token: this.apiAuthToken,
          user_tags: userTags,
          comment: comment,
          post_id: postId
        },
        method: "post",
        responseType: "json",
      })
        .then((res) => {
          this.getAfterFeed();
          this.closeModal();
          this.scrollToTop();
          if (res.data.type == 'update') {
            this.toastSuccessPostPhoto(this.photoEditSuccessMessage);
          } else {
            this.toastSuccessPostPhoto(this.photoSuccessMessage);
          }
        })
        .catch((err) => {
          console.log(err);
          this.toastErrorPostPhoto();
        })
        .finally(() => {
          this.fetching.submittingPhoto = this.$fetchStates.idle;
        });
    },

    submitFilePost(form, comment, userTags, postId) {
      var formData = new FormData(form);
      formData.append("api_auth_token", this.apiAuthToken);
      if (comment) formData.append("comment", comment);
      if (userTags && userTags.length) formData.append("user_tags", userTags);
      if (postId) formData.append("post_id", postId);
      this.fetching.submittingPhoto = this.$fetchStates.fetching;

      var url = this.getFormattedURL(`/photo-streams/${this.streamId}/photos`);

      axios({
        url: url,
        data: formData,
        method: "POST",
      })
        .then((res) => {
          this.getAfterFeed();
          this.closeModal();
          this.scrollToTop();
          if (res.data.type == 'update') {
            this.toastSuccessPostPhoto(this.photoEditSuccessMessage);
          } else {
            this.toastSuccessPostPhoto(this.photoSuccessMessage);
          }
        })
        .catch((err) => {
          console.log(err);
          this.toastErrorPostPhoto();
        })
        .finally(() => {
          this.fetching.submittingPhoto = this.$fetchStates.idle;
        });
    },

    commentOnPhoto(photo, comment, parentId) {
      var url = this.getFormattedURL(`/photo-streams/${this.streamId}/photos/${photo.id}/comments`);

      axios({
        url: url,
        data: {
          api_auth_token: this.apiAuthToken,
          comment: {
            comment: comment,
            parent_id: parentId,
          },
        },
        method: "POST",
        responseType: "json",
      })
        .then((res) => {
          if (res.data && res.data.data) {
            var updatedPhoto = this.photos.find((foto) => foto.id === photo.id);
            if (updatedPhoto) updatedPhoto.comments = res.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    editCommentOnPhoto(comment, editedText) {
      var url = this.getFormattedURL(`/photo-streams/${this.streamId}/photos/${comment.commentable_id}/comments/${comment.id}`);

      axios({
        url: url,
        data: {
          api_auth_token: this.apiAuthToken,
          comment: editedText,
        },
        method: "PUT",
        responseType: "json",
      })
      .then((res) => {
          var updatedPhoto = this.photos.find((photo) => photo.id === comment.commentable_id);
          if (updatedPhoto) {
            var updatedComment = updatedPhoto.comments.find((c) => c.id === comment.id);
            console.log(updatedPhoto);
            if (updatedComment) updatedComment.comment = editedText;
          }
      })
      .catch((err) => {
        console.log(err);
      });
    },

    likePost(photo, like) {
      var url = this.getFormattedURL(`/photo-streams/${this.streamId}/photos/${photo.id}/likes`);

      axios({
        method: "POST",
        url: url,
        data: { api_auth_token: this.apiAuthToken },
        responseType: "json",
      })
        .then((res) => {
          if (res.data && res.data.like) {
            // should probably clean up endpoint, gives 200 even when does not create when one already exists,
            // dont know what else uses atm though
            const newLike = res.data.like;
            if (photo.likes.find((like) => like.id === newLike.id)) return;
            var newPhoto = this.photos.find((foto) => foto.id === photo.id);
            newPhoto.likes.push(newLike);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    unLikePost(photo, like) {
      var url = this.getFormattedURL(
        `/photo-streams/${this.streamId}/photos/${photo.id}/likes/${like.id}`
      );

      axios({
        method: "DELETE",
        url: url,
        data: { api_auth_token: this.apiAuthToken },
        responseType: "json",
      })
        .then((res) => {
          var newPhoto = this.photos.find((foto) => foto.id === photo.id);
          newPhoto.likes = photo.likes.filter((l) => l.id !== like.id);
          this.photos.forEach((foto) => {
            if (foto.id === newPhoto) foto = newPhoto;
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    approvedPhoto(photo) {
      this.photos.forEach((foto) => {
        if (foto.id === photo.id) {
          foto.approved = photo.approved;
        }
      });
    },

    deniedPhoto(photo) {
      this.photos.forEach((foto) => {
        if (foto.id === photo.id) {
          foto.hidden = photo.hidden;
        }
      });
    },

    deletePhoto(photo) {
      this.fetchFeed();
    },

    addScrollListenerForRightAffix() {
      let ticking;
      let navHeight = 75 - 24;
      const nav = document.getElementById("photostream-nav");
      if (nav) {
        navHeight = nav.offsetHeight - 24;
      }

      const mobileNav = document.getElementsByClassName("mobile-navbar-external")[0];

      const main = $("main")
      if (!main.length) return;
      
      $("main")[0].addEventListener(
        "scroll",
        function (e) {
          if (!ticking) {
            window.requestAnimationFrame(() => {
              var self = this;

              var totalNavHeight = navHeight;
              if (mobileNav) totalNavHeight + mobileNav.offsetHeight;

              if (totalNavHeight < $("main").scrollTop()) {
                this.$refs.showModalBtn.style.position = "fixed";
              } else {
                this.$refs.showModalBtn.style.position = "";
              }
              ticking = false;
            });
            ticking = true;
          }
        }.bind(this)
      );
    },

    checkForLazyLoad: function() {
				if (!this.photos || this.photos.length == 0 ) return;
				var self = this
				var combined = Math.max($('#photo-stream-app-content').offset().top + $('#photo-stream-app-content').outerHeight() - window.innerHeight,150);

				if($(window).scrollTop() >= (combined - 100)) {
					if(self.hasMoreFeed){
						if (!self.fetchingBeforeFeed) {
							self.getBeforeFeed();
						}
					}
					else clearInterval(self.initialLazyLoad)
				}
				else clearInterval(self.initialLazyLoad)
			},

    joinPhotoStreamPhotoPusherChannel () {
      var self = this
      window.Echo.channel(`photo-stream.${this.eventId}.${this.streamId}`)
          .listen('PhotoStreamPhotoBroadcastEvent', (res) => {
            if (res && res.action  === 'deleted') {
              self.photos = self.photos.filter(photo => photo.id !== res.photo_id);
            }   
      });

      window.Echo.channel(`comments.${this.eventId}.${this.streamId}`)
        .listen('CommentBroadcastEvent', (e) => {
            const { action, comment } = e;
            const photo = self.photos.find(photo => photo.id === comment.commentable_id);

            if(action === 'created') {
                handleCommentCreated(photo, comment);
            } else if (action === 'updated') {
                handleCommentUpdated(photo, comment);
            } else if (action === 'deleted') {
                handleCommentDeleted(photo, comment);
            }
      })

      function handleCommentCreated(photo, comment) {
          photo.comments.push(comment);
      }

      function handleCommentUpdated(photo, comment) {
          let existingComment = photo.comments.find(existingComment => existingComment.id === comment.id);
          Object.assign(existingComment, comment);
      }

      function handleCommentDeleted(photo, comment) {
          let commentIndex = photo.comments.findIndex(existingComment => existingComment.id === comment.id);
          photo.comments.splice(commentIndex, 1);
      }

    },

  },

  mounted() {
    let self = this;
    // pass plugin data for presence reporting
    window.pluginData = { pluginType: "PhotoStream", pluginId: this.streamId };

    this.fetchFeed();

    this.joinPhotoStreamPhotoPusherChannel()

    this.$on("close", () => {
      this.showModal = false;
    });
    this.addScrollListenerForRightAffix();

    this.$root.$on("search-value", (val) => {
      this.fetchFeed(val);
    });

    if (this.lazyLoadEnabled){
      this.initialLazyLoad = setInterval(this.checkForLazyLoad, 2000)
      $(window).bind('scroll', function() {
        self.checkForLazyLoad()
      });
    }

    window.addEventListener("resize", this.listenerForColumnLayout);
    const searchParams = window.location.search;
    if (searchParams.includes("open-modal")) {
      this.openModal();
    }

    window.EventBus.$on('open-modal', function () {
      this.openModal();
    }.bind(this))
  },
  unmounted() {
    window.removeEventListener("resize", this.listenerForColumnLayout);
  },
};
</script>

<style scoped>

.base-np-modal-user-info {
  display: none;
}
.psa__content {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 1300px) {
  .nav-side .psa__content {
    margin-left: 0;
    margin-right: 0;
  }
  .nav-side .photo-stream__content .col-8 {
    max-width: 100%;
  }
}

.photo-preview {
  width: 50%;
}

.psa__show-more-btn {
  width: 100%;
  margin-top: 2rem;
  margin-bottom: 2rem;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-color: var(--theme-primary-color);
}

.show-more-spinner {
  width: 100%;
  margin: 2rem;
  padding: 1rem;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.show-more-text {
  padding-right: 2rem;
}

.psa__post-btn {
  position: fixed;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 1rem;
  /* top: calc(var(--plugin-title-side-nav) + var(--plugin-content-padding)); */
  cursor: pointer;
  /* background-color: black; */
  max-width: 12rem;
  font-weight: bold;
}

.nav-top .psa__post-btn {
  /* top: calc(var(--plugin-title-top-nav) + var(--plugin-content-padding));
    margin-top: var(--hs-topnav-height); */
  top: unset !important;
  margin-top: unset !important;
}

.psa__post-btn .fa-plus {
  padding-top: 3px;
}
.psa__post-btn > * {
  margin-left: 0.2rem;
  margin-right: 0.2rem;
}
/* @media (max-width: 900px) {
     .psa__post-btn {
       margin-top: 2.5rem;
     }

  } */

/* @media (max-width: 895px) { 
    .psa__post-btn  {
      top: calc(var(--hs-mobilenav-height) + var(--plugin-title-sid-nav));
    }
  } */

.psa__post-btn,
.nav-top .psa__post-btn {
  position: fixed;
  left: 50%;
  bottom: 4rem;
  top: unset;
  width: fit-content;
  border-radius: 50% !important;
  min-width: unset;
  transform: translateX(-50%) !important;
  align-items: center;
}
.psa__post-btn i {
  font-size: 2em;
}
.psa__post-btn-text {
  display: none;
}
.psa__card-containter {
  padding: 0;
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  max-width: 1200px;
  margin: 0 auto;
}

.nav-side .psa__card-containter {
  flex-grow: 1;
  max-width: unset;
}

.psa__loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2rem;
}

.toasted {
  margin-top: 0px !important;
}

.psa__error-fetching-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 50vh;
  justify-content: space-around;
}

.psa__reload-btn {
  padding: 0.6rem 2rem;
  border-radius: 80px;
  background-color: rgba(0, 0, 0, 0%);
  cursor: pointer;
  z-index: 100;
}

.base-psa__show-more-btn {
  display: none;
}

@media (min-width: 896px) {
  .psa__post-btn,
  .nav-top .psa__post-btn {
    border-radius: 0 !important;
  }
  .psa__post-btn-text {
    display: inline-block;
  }
  .psa__post-btn i {
    font-size: 22px;
  }
}
</style>
